import {InlineMath} from "react-katex";

const SoftwareEngineering = () => {
    return (
        <div className="max-w-4xl mx-auto px-4">

            <h1 className="tw-header font-bold text-gray-900 mb-4">Software Engineering</h1>
            <p className="text-gray-600 tw-subtitle text-justify">
                Software engineering is the structured approach to designing, developing, and maintaining software
                systems.
                It focuses on creating reliable, efficient, and scalable code, not "just" solving problems, but solving
                them well. It is called software, as it is the soft components within the <strong
                className="font-bold">hard</strong>ware,being the electrical activations, of on or off.
            </p>

            <hr className="mt-2 mb-2"/>

            <p className="text-gray-600 tw-subtitle text-justify">
                Behind the code, software engineering is filled with logic and math. We use formal logic to validate
                behavior,
                graph theory to model systems and dependencies, and time complexity (like <InlineMath
                math="O(n \log n)"/> or <InlineMath math="O(1)"/>)
                to reason about performance.
            </p>

            <p className="text-gray-600 tw-subtitle text-justify">
                It also brings structure through design patterns, modularity, and best practices that allow teams to
                build
                large systems collaboratively without losing control.
            </p>

            <hr className="mt-2 mb-2"/>

            <p className="text-gray-600 tw-subtitle text-justify">
                In this section, we’ll cover essential topics like:
                <ul className="list-disc list-inside mt-2">
                    <li>Clean architecture and code design</li>
                    <li>Version control and collaboration (e.g., Git)</li>
                    <li>Testing and debugging strategies</li>
                    <li>Basic performance analysis and algorithmic thinking</li>
                </ul>
                Whether you're building web apps, mobile tools, or backend systems, these principles will help
                you build software that lasts, and works well under pressure.
            </p>
        </div>
    );
}

export default SoftwareEngineering;
